import(/* webpackMode: "eager" */ "/codebuild/output/src4090843079/src/patient-app/app/global-error.tsx");
